import React from "react";
import FaqsComponent from "../modules/Faqs";

function FaqsPage() {
  return <FaqsComponent />;
}

export default FaqsPage;